import { render, staticRenderFns } from "./AlertDetailFromWhatsApp.vue?vue&type=template&id=2cca6722&scoped=true"
import script from "./AlertDetailFromWhatsApp.vue?vue&type=script&lang=js"
export * from "./AlertDetailFromWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./AlertDetailFromWhatsApp.vue?vue&type=style&index=0&id=2cca6722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca6722",
  null
  
)

export default component.exports